import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { setSeo } from "../lib/seo";

export function AuthPage() {
  const { user, login, loginWithEmail, registerWithEmail, error } = useAuth();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [localError, setLocalError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    setSeo({ title: "Sign In | My Local Forum", path: "/auth", noindex: true });
  }, []);

  useEffect(() => {
    if (user) navigate("/profile", { replace: true });
  }, [user, navigate]);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLocalError(null);
    const form = new FormData(event.currentTarget);
    const email = String(form.get("email") || "").trim();
    const nickname = String(form.get("nickname") || "").trim();
    const password = String(form.get("password") || "");
    const confirmPassword = String(form.get("confirmPassword") || "");

    if (!email || !password || (mode === "register" && !nickname)) {
      setLocalError("Please fill all required fields.");
      return;
    }

    if (mode === "register" && password !== confirmPassword) {
      setLocalError("Passwords do not match.");
      return;
    }

    if (mode === "register") {
      await registerWithEmail(email, password, nickname);
    } else {
      await loginWithEmail(email, password);
    }
  }

  return (
    <section className="page auth-page">
      <h1>{mode === "register" ? "Register" : "Sign In"}</h1>
      <div className="panel">
        <div className="segmented">
          <button className={mode === "login" ? "active" : ""} onClick={() => setMode("login")}>
            Sign In
          </button>
          <button className={mode === "register" ? "active" : ""} onClick={() => setMode("register")}>
            Register
          </button>
        </div>

        <form className="form-grid" onSubmit={submit}>
          {mode === "register" ? <input name="nickname" placeholder="Username / nickname" autoComplete="nickname" /> : null}
          <input name="email" placeholder="Email" type="email" autoComplete="email" />
          <input name="password" placeholder="Password" type="password" autoComplete={mode === "register" ? "new-password" : "current-password"} />
          {mode === "register" ? (
            <input name="confirmPassword" placeholder="Confirm password" type="password" autoComplete="new-password" />
          ) : null}
          <button className="primary-button" type="submit">
            {mode === "register" ? "Create Account" : "Sign In"}
          </button>
        </form>

        <button className="ghost-button full-width" onClick={login}>
          Continue with Google
        </button>

        {localError || error ? <div className="auth-error inline-error">{localError || error}</div> : null}
      </div>
    </section>
  );
}
